/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Showgridview2Inputs */

const id_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan tampilan grid`)
};

const ms_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunjukkan paparan grid`)
};

const da_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis gittervisning`)
};

const de_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasteransicht zeigen`)
};

const en_us2_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show grid view`)
};

const es_es2_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar vista de cuadrícula`)
};

const es_mx2_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar vista de cuadrícula`)
};

const fil_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipakita ang grid view`)
};

const fr_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher en grille`)
};

const it_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra vista griglia`)
};

const hu_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rács nézet mutatása`)
};

const nl_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasterweergave tonen`)
};

const no_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis rutevisning`)
};

const pl_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż widok siatki`)
};

const pt_br2_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar visualização em grade`)
};

const pt_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar vista de grelha`)
};

const ro_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afișare grilă`)
};

const fi_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä ruudukkonäkymä`)
};

const sv_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa rutnätsvy`)
};

const vi_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiển thị dạng lưới`)
};

const tr_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izgara görünümünü göster`)
};

const cs_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit jako mřížku`)
};

const bg_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показване на изглед като мрежа`)
};

const ru_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать сеткой`)
};

const uk_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показати сіткою`)
};

const ar_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الشبكة`)
};

const hi_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रिड दृश्य दिखाएँ`)
};

const th_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แสดงมุมมองตาราง`)
};

const ja_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリッド表示`)
};

const zh_cn2_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示网格视图`)
};

const zh_hant1_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顯示網格檢視`)
};

const ko_search_sort_showgridview2 = /** @type {(inputs: Search_Sort_Showgridview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그리드 보기`)
};

/**
* | output |
* | --- |
* | "Show grid view" |
*
* @param {Search_Sort_Showgridview2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_showgridview2 = /** @type {((inputs?: Search_Sort_Showgridview2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Showgridview2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_showgridview2(inputs)
	if (locale === "ms") return ms_search_sort_showgridview2(inputs)
	if (locale === "da") return da_search_sort_showgridview2(inputs)
	if (locale === "de") return de_search_sort_showgridview2(inputs)
	if (locale === "en-US") return en_us2_search_sort_showgridview2(inputs)
	if (locale === "es-ES") return es_es2_search_sort_showgridview2(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_showgridview2(inputs)
	if (locale === "fil") return fil_search_sort_showgridview2(inputs)
	if (locale === "fr") return fr_search_sort_showgridview2(inputs)
	if (locale === "it") return it_search_sort_showgridview2(inputs)
	if (locale === "hu") return hu_search_sort_showgridview2(inputs)
	if (locale === "nl") return nl_search_sort_showgridview2(inputs)
	if (locale === "no") return no_search_sort_showgridview2(inputs)
	if (locale === "pl") return pl_search_sort_showgridview2(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_showgridview2(inputs)
	if (locale === "pt") return pt_search_sort_showgridview2(inputs)
	if (locale === "ro") return ro_search_sort_showgridview2(inputs)
	if (locale === "fi") return fi_search_sort_showgridview2(inputs)
	if (locale === "sv") return sv_search_sort_showgridview2(inputs)
	if (locale === "vi") return vi_search_sort_showgridview2(inputs)
	if (locale === "tr") return tr_search_sort_showgridview2(inputs)
	if (locale === "cs") return cs_search_sort_showgridview2(inputs)
	if (locale === "bg") return bg_search_sort_showgridview2(inputs)
	if (locale === "ru") return ru_search_sort_showgridview2(inputs)
	if (locale === "uk") return uk_search_sort_showgridview2(inputs)
	if (locale === "ar") return ar_search_sort_showgridview2(inputs)
	if (locale === "hi") return hi_search_sort_showgridview2(inputs)
	if (locale === "th") return th_search_sort_showgridview2(inputs)
	if (locale === "ja") return ja_search_sort_showgridview2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_showgridview2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_showgridview2(inputs)
	return ko_search_sort_showgridview2(inputs)
});
export { search_sort_showgridview2 as "search.sort.showGridView" }